export default [
    {
        path: 'exportacao',
        component: () => import(/* webpackChunkName: 'raas-exportacao' */ '@/views/raas/exportacao/Index'),
        redirect: 'exportacao/index',
        children: [
            {
                name: 'raas-exportacao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'raas-exportacao-index' */'@/views/raas/exportacao/List.vue'),
            },
        ],
    },
]